<si-about-page
  [aboutData] = "aboutData"
></si-about-page>
